/**
 * Web Style Import
 *
 */

import './dnb-badge.scss'
